/**
 * Phone helpers for the location forms. vendor-api stores E.164; vendors type
 * US numbers however they like ("(704) 555-0123"). Only US/CA (+1) is inferred
 * from a bare 10-digit entry — anything else must already carry its `+`.
 */
export function toE164(input: string): string | null {
  const raw = input.trim();
  if (!raw) return null;
  if (raw.startsWith('+')) {
    const digits = raw.slice(1).replace(/\D/g, '');
    return /^[1-9]\d{6,14}$/.test(digits) ? `+${digits}` : null;
  }
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return null;
}

/** "+17045550123" → "(704) 555-0123"; other countries are shown as stored. */
export function fromE164(e164: string | null | undefined): string {
  if (!e164) return '';
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164;
}
